import { useEffect, useState } from "react";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const useWalletHealthCheck = () => {
  const [healthData, setHealthData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHealthCheck = async () => {
      try {
        setLoading(true);
        const response = await AxiosGetMethod("org/wallet/health-check");
        if (response.status === 200 && response.data?.data) {
          setHealthData(response.data.data);
        } else {
          if (response?.status === 401) HandleLogout();
          setHealthData(null);
        }
      } catch (err) {
        setHealthData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchHealthCheck();
  }, []);

  return { healthData, loading, setHealthData };
};

export default useWalletHealthCheck;